import { useEffect } from 'react';
import { useParams } from 'react-router';
import urlTemplate from 'url-template';
import type { Transaction } from 'src/apis/surrender-service/types';
import type { SurrenderRootRequest } from 'src/apis/surrender-service/use-surrender-root';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

type RequestOptions = {
  url: string;
};

export function useTransaction(surrenderRoot: SurrenderRootRequest) {
  const { transactionId } = useParams<{ transactionId: string }>();

  const transaction = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<Transaction>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!surrenderRoot.response) return;

    if (!surrenderRoot.response.data._links.getTransaction)
      throw new Forbidden();

    const url = urlTemplate
      .parse(surrenderRoot.response.data._links.getTransaction.href)
      .expand({ transactionId });

    transaction.execute({ url });

    // oxlint-disable-next-line exhaustive-deps
  }, [surrenderRoot.response, transactionId]);

  return transaction;
}

export type TransactionRequest = ReturnType<typeof useTransaction>;
